/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Info_OpenInputs */

const en_us2_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What does this mean?`)
};

const pt_br2_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que isso significa?`)
};

const es_419_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué significa esto?`)
};

const pt_pt2_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que significa isto?`)
};

const fr_fr2_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qu'est-ce que ça veut dire ?`)
};

const de_de2_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was bedeutet das?`)
};

const it_it2_exercise_personal_info_open = /** @type {(inputs: Exercise_Personal_Info_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa significa?`)
};

/**
* | output |
* | --- |
* | "What does this mean?" |
*
* @param {Exercise_Personal_Info_OpenInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_info_open = /** @type {((inputs?: Exercise_Personal_Info_OpenInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Info_OpenInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_info_open(inputs)
	if (locale === "es-419") return es_419_exercise_personal_info_open(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_info_open(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_info_open(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_info_open(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_info_open(inputs)
	return en_us2_exercise_personal_info_open(inputs)
});
export { exercise_personal_info_open as "exercise-personal.info_open" }